module.exports = __webpack_public_path__ + "static/media/Kenneth Pratt_1612007254486.9bfe258c.jpeg";